/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { action, makeObservable, observable } from 'mobx';
import { Course } from '../../types/course/Course';
import { initialEmoji } from './PickEmojiModel';

export class CourseModel {
	@observable
	public courses: Course[] = [];

	@observable
	public course: Course = {
		emoji: initialEmoji,
		name: '',
		startDate: null,
		courseId: '',
		courseMember: 0,
		students: [],
	};

	@observable
	public hasCourseStarted = false;

	@observable
	public canCourseBeEdited = false;

	constructor() {
		makeObservable(this);
	}

	@action
	setCourses(courses: Course[]): void {
		this.courses = courses;
	}

	@action
	setCourse(course: Course): void {
		this.course = course;
	}

	@action
	setCourseName(name: string): void {
		this.course.name = name;
	}

	@action
	setHasCourseStarted(bool: boolean): void {
		this.hasCourseStarted = bool;
	}

	@action
	setCanCourseBeEdited(bool: boolean): void {
		this.canCourseBeEdited = bool;
	}
}
